import React from 'react';
import { Link } from 'react-router-dom';
import {useTranslation} from "react-i18next";


const Footer: React.FC = () => {
    const loginToMiniapp = () => {
        window.location.href = "https://account.kirenagainvest.com/login"
      };
    const registerToMiniapp = () => {
        window.location.href = "https://account.kirenagainvest.com/registration"
      };
    const { t, i18n } = useTranslation() as {
        t: (key: string, options?: any) => string;
        i18n: {
            language: string;
        }
    };

    const currentLanguage = i18n.language
  return (
    <>
    <footer className="bg-black py-8 md:py-16" id='contacts'>
        <div className="px-4 sm:px-6 md:px-20 w-full">
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 md:gap-20">
                <div className="">
                    <div className="flex items-start md:mb-6">
                    <a href="/">
                        <div className="flex flex-row items-center">
                        <img 
                            src={require('../../assets/images/logo.png')} 
                            alt="Liberty Investment Kirenaga Logo" 
                            className="h-16 md:h-24 mr-2 md:mr-4"
                        />
                        <div className="text-white text-xl md:text-xl font-druk font-bold leading-[95%]">
                            LIBERTY<br />
                            INVESTMENT<br />
                            KIRENAGA
                        </div>
                        </div>
                    </a>
                    </div>

                    <div className="hidden md:block text-white mt-6">
                        <p className="mb-2">{t('footerCentralFloridaOffice')}</p>
                        <p className="text-white text-sm">E-mail: <a href="mailto:info@kirenagainvest.com">info@kirenagainvest.com</a></p>
                    </div>
                </div>
                    
            <div className="mt-8">
              <h4 className="text-[#BCDE02] font-bold text-xl mb-6 uppercase">{t('products')}</h4>
              <ul className="md:space-y-2 text-lg">
                <li><Link to="/products/trading" className="text-white hover:text-[#BCDE02] transition-colors">TRADING</Link></li>
                <li><Link to="/products/staking" className="text-white hover:text-[#BCDE02] transition-colors">STAKING</Link></li>
                <li><Link to="/products/thorchain" className="text-white hover:text-[#BCDE02] transition-colors">THORCHAIN NODES</Link></li>
                <li><a href="/#cannabis" className="text-white hover:text-[#BCDE02] transition-colors">CANNABIS</a></li>
                <li><a href="/#casino" className="text-white hover:text-[#BCDE02] transition-colors">CASINO</a></li>
              </ul>
            </div>
            
            <div className="mt-8">
                <h4 className="text-[#BCDE02] font-bold text-xl mb-6">{t('footerAccount')}</h4>
                <ul className="md:space-y-2 text-lg">
                    <li><div onClick={() => loginToMiniapp()} className="text-white hover:text-[#BCDE02] transition-colors">{ t('login') }</div></li>
                    <li><div onClick={() => registerToMiniapp()} className="text-white hover:text-[#BCDE02] transition-colors">{ t('registration') }</div></li>
                </ul>

                <div className="block md:hidden mt-8">
                    <h4 className="text-[#BCDE02] font-bold text-xl mb-6">{t('footerSocialNetworks')}</h4>
                    <div className="flex">
                    <a href={t('tg_link')} className="flex hover:text-[#0088cc]">
                        <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="32" 
                        height="32" 
                        viewBox="0 0 24 24" 
                        fill="#0088cc"
                        className="w-12 h-12"
                        >
                        <path d="M9.78,18.65L10.06,14.37L17.74,7.5C18.08,7.19 17.67,7.04 17.22,7.31L7.74,13.3L3.64,12C2.76,11.75 2.75,11.14 3.84,10.7L19.81,4.54C20.54,4.21 21.24,4.72 20.96,5.84L18.24,18.65C18.05,19.56 17.5,19.78 16.74,19.36L12.6,16.3L10.61,18.23C10.38,18.46 10.19,18.65 9.78,18.65Z"/>
                        </svg>
                    </a>
                    <a href={t('inst_link')} className="flex justify-center items-center ml-2">
                        <svg 
                        xmlns="http://www.w3.org/2000/svg"
                        width="32" 
                        height="32" 
                        viewBox="0 0 23 23" 
                        fill="none" 
                        stroke="#FFFFFF" 
                        className='flex justify-center items-center'
                        // stroke-width="2" 
                        stroke-linecap="round" 
                        stroke-linejoin="round" ><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
                    </a>
                    <a href={t('yt_link')} className="flex justify-center items-center ml-3">
                        <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                            <title>Youtube</title>
                            <g id="Icon/Social/youtube-black" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path d="M20.2838235,29.7208546 L20.2817697,19.3775851 L30.0092421,24.5671906 L20.2838235,29.7208546 Z M41.6409276,17.5856462 C41.6409276,17.5856462 41.2890436,15.0488633 40.2097727,13.9319394 C38.8405739,12.4655276 37.3060444,12.4583393 36.6026186,12.3724221 C31.5649942,12 24.008044,12 24.008044,12 L23.9922983,12 C23.9922983,12 16.4356904,12 11.398066,12.3724221 C10.6939556,12.4583393 9.16045298,12.4655276 7.79091194,13.9319394 C6.71164104,15.0488633 6.36009927,17.5856462 6.36009927,17.5856462 C6.36009927,17.5856462 6,20.5646804 6,23.5437145 L6,26.3365376 C6,29.3152295 6.36009927,32.2946059 6.36009927,32.2946059 C6.36009927,32.2946059 6.71164104,34.8310466 7.79091194,35.9483127 C9.16045298,37.4147246 10.9592378,37.3681718 11.7605614,37.5218644 C14.6406709,37.8042616 24.0001711,37.8915481 24.0001711,37.8915481 C24.0001711,37.8915481 31.5649942,37.8799099 36.6026186,37.5074878 C37.3060444,37.4219129 38.8405739,37.4147246 40.2097727,35.9483127 C41.2890436,34.8310466 41.6409276,32.2946059 41.6409276,32.2946059 C41.6409276,32.2946059 42,29.3152295 42,26.3365376 L42,23.5437145 C42,20.5646804 41.6409276,17.5856462 41.6409276,17.5856462 L41.6409276,17.5856462 Z" id="Shape" fill="#FFFFFF"></path>
                            </g>
                        </svg>
                    </a>
                    {/* {
                        (currentLanguage == "en" || currentLanguage == "ru") && <>
                                <a href="https://www.youtube.com/@LibertyInvestmentKirenagaLIK" className="flex justify-center items-center ml-3">
                                <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                                    <title>Youtube</title>
                                    <g id="Icon/Social/youtube-black" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <path d="M20.2838235,29.7208546 L20.2817697,19.3775851 L30.0092421,24.5671906 L20.2838235,29.7208546 Z M41.6409276,17.5856462 C41.6409276,17.5856462 41.2890436,15.0488633 40.2097727,13.9319394 C38.8405739,12.4655276 37.3060444,12.4583393 36.6026186,12.3724221 C31.5649942,12 24.008044,12 24.008044,12 L23.9922983,12 C23.9922983,12 16.4356904,12 11.398066,12.3724221 C10.6939556,12.4583393 9.16045298,12.4655276 7.79091194,13.9319394 C6.71164104,15.0488633 6.36009927,17.5856462 6.36009927,17.5856462 C6.36009927,17.5856462 6,20.5646804 6,23.5437145 L6,26.3365376 C6,29.3152295 6.36009927,32.2946059 6.36009927,32.2946059 C6.36009927,32.2946059 6.71164104,34.8310466 7.79091194,35.9483127 C9.16045298,37.4147246 10.9592378,37.3681718 11.7605614,37.5218644 C14.6406709,37.8042616 24.0001711,37.8915481 24.0001711,37.8915481 C24.0001711,37.8915481 31.5649942,37.8799099 36.6026186,37.5074878 C37.3060444,37.4219129 38.8405739,37.4147246 40.2097727,35.9483127 C41.2890436,34.8310466 41.6409276,32.2946059 41.6409276,32.2946059 C41.6409276,32.2946059 42,29.3152295 42,26.3365376 L42,23.5437145 C42,20.5646804 41.6409276,17.5856462 41.6409276,17.5856462 L41.6409276,17.5856462 Z" id="Shape" fill="#FFFFFF"></path>
                                    </g>
                                </svg>
                                </a>
                        </>
                    } */}
                    <a href="https://x.com/LikKirenaga" className="flex justify-center items-center ml-3">
                        <svg width="32" height="32" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
                        </svg>
                    </a>
                    </div>
                </div>


              {/* <h4 className="text-[#BCDE02] font-bold text-xl mt-10 mb-6">{t('footerDocuments')}</h4> */}
                {/* <ul className="space-y-3 text-xl">
                    <li><Link to="/privacy" className="text-white hover:text-[#BCDE02] transition-colors">Политика конфиденциальности</Link></li>
                </ul> */}
            </div>
            
            <div className="hidden md:block mt-8">
              <h4 className="text-[#BCDE02] font-bold text-xl mb-6">{t('footerSocialNetworks')}</h4>
              <div className="flex">
                    <a href={t('tg_link')} className="flex hover:text-[#0088cc]">
                        <svg 
                        xmlns="http://www.w3.org/2000/svg" 
                        width="32" 
                        height="32" 
                        viewBox="0 0 24 24" 
                        fill="#0088cc"
                        className="w-12 h-12"
                        >
                        <path d="M9.78,18.65L10.06,14.37L17.74,7.5C18.08,7.19 17.67,7.04 17.22,7.31L7.74,13.3L3.64,12C2.76,11.75 2.75,11.14 3.84,10.7L19.81,4.54C20.54,4.21 21.24,4.72 20.96,5.84L18.24,18.65C18.05,19.56 17.5,19.78 16.74,19.36L12.6,16.3L10.61,18.23C10.38,18.46 10.19,18.65 9.78,18.65Z"/>
                        </svg>
                    </a>
                    <a href={t('inst_link')} className="flex justify-center items-center ml-2">
                        <svg 
                        xmlns="http://www.w3.org/2000/svg"
                        width="32" 
                        height="32" 
                        viewBox="0 0 23 23" 
                        fill="none" 
                        stroke="#FFFFFF" 
                        className='flex justify-center items-center'
                        // stroke-width="2" 
                        stroke-linecap="round" 
                        stroke-linejoin="round" ><rect width="20" height="20" x="2" y="2" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/></svg>
                    </a>
                    <a href={t('yt_link')} className="flex justify-center items-center ml-3">
                        <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                            <title>Youtube</title>
                            <g id="Icon/Social/youtube-black" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <path d="M20.2838235,29.7208546 L20.2817697,19.3775851 L30.0092421,24.5671906 L20.2838235,29.7208546 Z M41.6409276,17.5856462 C41.6409276,17.5856462 41.2890436,15.0488633 40.2097727,13.9319394 C38.8405739,12.4655276 37.3060444,12.4583393 36.6026186,12.3724221 C31.5649942,12 24.008044,12 24.008044,12 L23.9922983,12 C23.9922983,12 16.4356904,12 11.398066,12.3724221 C10.6939556,12.4583393 9.16045298,12.4655276 7.79091194,13.9319394 C6.71164104,15.0488633 6.36009927,17.5856462 6.36009927,17.5856462 C6.36009927,17.5856462 6,20.5646804 6,23.5437145 L6,26.3365376 C6,29.3152295 6.36009927,32.2946059 6.36009927,32.2946059 C6.36009927,32.2946059 6.71164104,34.8310466 7.79091194,35.9483127 C9.16045298,37.4147246 10.9592378,37.3681718 11.7605614,37.5218644 C14.6406709,37.8042616 24.0001711,37.8915481 24.0001711,37.8915481 C24.0001711,37.8915481 31.5649942,37.8799099 36.6026186,37.5074878 C37.3060444,37.4219129 38.8405739,37.4147246 40.2097727,35.9483127 C41.2890436,34.8310466 41.6409276,32.2946059 41.6409276,32.2946059 C41.6409276,32.2946059 42,29.3152295 42,26.3365376 L42,23.5437145 C42,20.5646804 41.6409276,17.5856462 41.6409276,17.5856462 L41.6409276,17.5856462 Z" id="Shape" fill="#FFFFFF"></path>
                            </g>
                        </svg>
                    </a>
                    {/* {
                        (currentLanguage == "en" || currentLanguage == "ru") && <>
                                <a href={t('yt_link')} className="flex justify-center items-center ml-3">
                                <svg width="48px" height="48px" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                                    <title>Youtube</title>
                                    <g id="Icon/Social/youtube-black" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                        <path d="M20.2838235,29.7208546 L20.2817697,19.3775851 L30.0092421,24.5671906 L20.2838235,29.7208546 Z M41.6409276,17.5856462 C41.6409276,17.5856462 41.2890436,15.0488633 40.2097727,13.9319394 C38.8405739,12.4655276 37.3060444,12.4583393 36.6026186,12.3724221 C31.5649942,12 24.008044,12 24.008044,12 L23.9922983,12 C23.9922983,12 16.4356904,12 11.398066,12.3724221 C10.6939556,12.4583393 9.16045298,12.4655276 7.79091194,13.9319394 C6.71164104,15.0488633 6.36009927,17.5856462 6.36009927,17.5856462 C6.36009927,17.5856462 6,20.5646804 6,23.5437145 L6,26.3365376 C6,29.3152295 6.36009927,32.2946059 6.36009927,32.2946059 C6.36009927,32.2946059 6.71164104,34.8310466 7.79091194,35.9483127 C9.16045298,37.4147246 10.9592378,37.3681718 11.7605614,37.5218644 C14.6406709,37.8042616 24.0001711,37.8915481 24.0001711,37.8915481 C24.0001711,37.8915481 31.5649942,37.8799099 36.6026186,37.5074878 C37.3060444,37.4219129 38.8405739,37.4147246 40.2097727,35.9483127 C41.2890436,34.8310466 41.6409276,32.2946059 41.6409276,32.2946059 C41.6409276,32.2946059 42,29.3152295 42,26.3365376 L42,23.5437145 C42,20.5646804 41.6409276,17.5856462 41.6409276,17.5856462 L41.6409276,17.5856462 Z" id="Shape" fill="#FFFFFF"></path>
                                    </g>
                                </svg>
                                </a>
                        </>
                    } */}

                    <a href="https://x.com/LikKirenaga" className="flex justify-center items-center ml-3">
                        <svg width="32" height="32" viewBox="0 0 1200 1227" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M714.163 519.284L1160.89 0H1055.03L667.137 450.887L357.328 0H0L468.492 681.821L0 1226.37H105.866L515.491 750.218L842.672 1226.37H1200L714.137 519.284H714.163ZM569.165 687.828L521.697 619.934L144.011 79.6944H306.615L611.412 515.685L658.88 583.579L1055.08 1150.3H892.476L569.165 687.854V687.828Z" fill="white"/>
                        </svg>
                    </a>
              </div>
              
            </div>
          </div>
        </div>

        <div className="bg-black pt-6">
            
            <div className="flex container flex-col pl-4 md:pl-10 items-left">
                <div className="block md:hidden text-white text-sm mb-10">
                    <p className="mb-2">{t('footerCentralFloridaOffice')}</p>
                    <p className="text-white">E-mail: <a href="mailto:info@kirenagainvest.com">info@kirenagainvest.com</a></p>
                </div>

                <div className="hidden md:block text-white text-sm">
                    {t('footerCopyright')}
                </div>
                <div className="mb-4 md:mb-0">
                    <Link to="/privacy" className="text-white text-sm md:text-lg hover:text-[#BCDE02] transition-colors underline">
                        {t('footerPrivacyLink')}
                    </Link>
                </div>
                <div className="block md:hidden text-white text-sm">
                    {t('footerCopyright')}
                </div>
            </div>
        </div>

      </footer>
    </>
  );
};

export default Footer;
